import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import React from "react";
import DocumentsForm from "../../../common/form/document/DocumentsForm";
import { baseEndpointPaths } from "../../../../../../services/serviceCalls";
import useFormReset from "../../../../../../hooks/useFormReset";
import useStepDocuments from "../../../../../../hooks/useStepDocuments";
import { fileGroups } from "../../../../../../config/fileGroupConfig";
import { ApplicationType } from "@duosoftbg/nacid-components";
import {
  completeDocumentStep,
  setStepDocumentsEdited,
} from "../../../../../../store/redux/slice/Forms/regprofAdditionalDocForm";

const RegprofAdditionalDocStepDocuments = () => {
  const regprofAdditionalDocForm = useAppSelector((state) => {
    return state.Forms.RegprofAdditionalDocForm;
  });

  const { methods, onSubmit } = useStepDocuments(
    regprofAdditionalDocForm,
    baseEndpointPaths.regprofAdditionalDoc,
    completeDocumentStep,
    setStepDocumentsEdited,
  );

  useFormReset("REGPROF_ADDITIONAL_DOCUMENTS", regprofAdditionalDocForm.documentDetails, methods.reset);

  return (
    <DocumentsForm
      methods={methods}
      onSubmit={onSubmit}
      setDocumentsFormEdited={setStepDocumentsEdited}
      hasAttachmentForm={true}
      hasAttachmentType={true}
      applicationId={regprofAdditionalDocForm.id}
      fileGroup={fileGroups.pdf}
      informingMessageCode={["m.seServices.applications.info"]}
      applicationType={ApplicationType.REGULATED_PROFESSIONS}
      applicationSubType={"REGPROF_ADDITIONAL_DOCUMENTS"}
    />
  );
};
export default RegprofAdditionalDocStepDocuments;
